module.exports = __webpack_public_path__ + "img/temple_of_snakes_small.5f958414.png";